<template>
  <NuxtLink
    :to="toLocalePath(linkTo)"
    class="block h-full"
    data-test-id="logo-mobile-link"
    :title="$t('header.logo_title')"
  >
    <svg
      v-if="!isGoldnerAnniversary"
      key="logo-mobile-default"
      width="100%"
      height="100%"
      viewBox="0 0 157 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="logo--default inline-block lg:hidden"
    >
      <title>{{ $t('header.logo_title') }}</title>
      <path
        d="M48.305 9.411h-.027c-.22.345-.517.595-.885.745-.369.151-.756.226-1.165.226-.301 0-.592-.043-.872-.126a2.155 2.155 0 0 1-.737-.38 1.843 1.843 0 0 1-.506-.623 1.907 1.907 0 0 1-.185-.864c0-.371.07-.686.207-.944a1.8 1.8 0 0 1 .56-.638c.233-.17.503-.299.804-.393.301-.094.613-.161.936-.207.323-.043.646-.07.971-.08.323-.009.622-.014.899-.014 0-.355-.127-.635-.38-.845a1.373 1.373 0 0 0-.898-.312c-.347 0-.627.07-.899.207a2.424 2.424 0 0 0-.723.565l-1.063-1.09a3.669 3.669 0 0 1 1.302-.777 4.67 4.67 0 0 1 1.542-.258c.584 0 1.065.072 1.442.22.376.145.678.36.904.646.226.285.382.632.47 1.044.09.411.132.888.132 1.428v3.285H48.3v-.81l.005-.005Zm-.492-2.02c-.151 0-.34.005-.565.019a2.865 2.865 0 0 0-.651.113 1.48 1.48 0 0 0-.533.28c-.145.123-.22.295-.22.519 0 .24.102.417.306.532.204.116.417.173.638.173.193 0 .384-.027.565-.081.18-.054.344-.13.484-.226.142-.097.255-.22.339-.371.083-.151.126-.329.126-.533V7.39h-.492.003ZM55.792 5.354h-1.754v2.155c0 .177.008.339.027.484a.968.968 0 0 0 .12.38.603.603 0 0 0 .286.247c.129.057.298.086.51.086.108 0 .246-.01.42-.032.173-.022.305-.073.393-.154v1.663c-.22.08-.452.132-.691.159a6.3 6.3 0 0 1-.705.04c-.336 0-.648-.035-.93-.107a2.08 2.08 0 0 1-.746-.34 1.59 1.59 0 0 1-.498-.605 2.082 2.082 0 0 1-.18-.904V5.354h-1.278V3.758h1.278V1.843h1.994v1.915h1.754v1.596ZM62.919 9.107c-.32.409-.724.724-1.211.944-.487.221-.993.334-1.515.334-.522 0-.963-.08-1.404-.24a3.336 3.336 0 0 1-1.144-.686 3.203 3.203 0 0 1-.764-1.07 3.396 3.396 0 0 1-.28-1.397c0-.514.095-.979.28-1.396a3.23 3.23 0 0 1 .764-1.07 3.422 3.422 0 0 1 1.144-.687c.438-.159.907-.24 1.404-.24.46 0 .88.081 1.257.24.376.159.696.387.957.686.261.296.463.654.606 1.07.142.418.212.883.212 1.397v.624h-4.627c.08.383.253.687.519.913.266.226.595.339.985.339.328 0 .605-.073.831-.221.226-.145.422-.334.592-.565l1.396 1.025h-.002Zm-1.69-2.847a1.155 1.155 0 0 0-.334-.863c-.231-.24-.527-.358-.89-.358a1.459 1.459 0 0 0-1.017.38 1.23 1.23 0 0 0-.393.844h2.634V6.26ZM64.46.168h1.994v10.054H64.46V.168ZM67.757 1.728c0-.32.113-.592.34-.818.225-.226.497-.339.817-.339.32 0 .592.113.818.34.226.225.339.497.339.817 0 .32-.113.592-.339.818a1.113 1.113 0 0 1-.818.34c-.32 0-.592-.114-.818-.34a1.113 1.113 0 0 1-.339-.818Zm.16 2.034h1.993v6.463h-1.994V3.762ZM77.468 9.107c-.32.409-.723.724-1.21.944-.487.221-.993.334-1.515.334-.522 0-.963-.08-1.404-.24a3.336 3.336 0 0 1-1.144-.686 3.203 3.203 0 0 1-.764-1.07 3.396 3.396 0 0 1-.28-1.397c0-.514.095-.979.28-1.396a3.23 3.23 0 0 1 .764-1.07 3.422 3.422 0 0 1 1.144-.687c.438-.159.906-.24 1.404-.24.46 0 .88.081 1.256.24.377.159.697.387.958.686.261.296.463.654.606 1.07.142.418.212.883.212 1.397v.624h-4.627c.08.383.252.687.519.913.266.226.594.339.984.339.329 0 .606-.073.832-.221.226-.145.422-.334.592-.565l1.396 1.025h-.003Zm-1.69-2.847a1.155 1.155 0 0 0-.333-.863c-.231-.24-.527-.358-.89-.358a1.458 1.458 0 0 0-1.017.38 1.23 1.23 0 0 0-.393.844h2.634V6.26ZM78.983 3.761h1.993V4.8h.027c.213-.398.466-.7.759-.899.293-.199.66-.298 1.103-.298.116 0 .232.005.347.013.116.008.22.027.32.054V5.49a2.803 2.803 0 0 0-.853-.132c-.382 0-.683.054-.903.16-.221.107-.393.255-.512.446a1.71 1.71 0 0 0-.231.686c-.035.266-.054.56-.054.877v2.699h-1.993V3.763l-.003-.003ZM59.053 31.978c-1.025.536-2.093.92-3.207 1.157a16.34 16.34 0 0 1-3.409.358c-1.232 0-2.367-.194-3.408-.578a7.795 7.795 0 0 1-2.696-1.66 7.535 7.535 0 0 1-1.77-2.618c-.423-1.025-.635-2.169-.635-3.43 0-1.262.212-2.406.635-3.43a7.533 7.533 0 0 1 1.77-2.619 7.783 7.783 0 0 1 2.696-1.66c1.038-.384 2.173-.578 3.408-.578 1.235 0 2.424.153 3.487.457a6.831 6.831 0 0 1 2.795 1.572l-2.45 2.671a4.897 4.897 0 0 0-1.604-1.114c-.595-.253-1.337-.38-2.228-.38-.742 0-1.415.127-2.015.38a4.55 4.55 0 0 0-1.547 1.058 4.61 4.61 0 0 0-.99 1.614 5.785 5.785 0 0 0-.344 2.026c0 .726.116 1.423.344 2.037.229.616.56 1.151.99 1.603.43.452.947.804 1.547 1.057.603.253 1.273.38 2.015.38.743 0 1.41-.086 1.962-.256.548-.17.987-.344 1.313-.524v-2.562h-2.828v-3.207h6.169v8.246ZM61.706 25.206c0-1.261.213-2.405.636-3.43a7.534 7.534 0 0 1 1.77-2.618c.756-.72 1.654-1.272 2.696-1.66 1.038-.384 2.173-.578 3.408-.578 1.235 0 2.368.194 3.409.578a7.832 7.832 0 0 1 2.695 1.66 7.534 7.534 0 0 1 1.77 2.618c.423 1.025.636 2.169.636 3.43 0 1.262-.213 2.406-.635 3.43a7.536 7.536 0 0 1-1.77 2.619 7.783 7.783 0 0 1-2.696 1.66c-1.039.384-2.177.578-3.409.578-1.232 0-2.367-.194-3.408-.578a7.794 7.794 0 0 1-2.696-1.66 7.536 7.536 0 0 1-1.77-2.618c-.423-1.025-.636-2.169-.636-3.43Zm3.608 0c0 .743.116 1.424.345 2.037.228.616.56 1.152.99 1.604.43.452.947.804 1.547 1.057.602.253 1.272.38 2.015.38.742 0 1.415-.127 2.015-.38a4.55 4.55 0 0 0 1.547-1.057c.43-.452.761-.988.99-1.604a5.808 5.808 0 0 0 .344-2.037 5.77 5.77 0 0 0-.344-2.025 4.65 4.65 0 0 0-.99-1.615 4.55 4.55 0 0 0-1.547-1.057c-.603-.253-1.273-.38-2.015-.38-.743 0-1.415.127-2.015.38a4.55 4.55 0 0 0-1.547 1.057 4.61 4.61 0 0 0-.99 1.615 5.783 5.783 0 0 0-.345 2.025ZM81.212 17.325h3.473v12.562h6.436v3.207H81.21V17.325h.002ZM94.377 17.325h5.212c1.261 0 2.461.14 3.597.423 1.135.282 2.128.74 2.972 1.369.848.632 1.518 1.453 2.016 2.462.497 1.009.745 2.236.745 3.675 0 1.278-.242 2.403-.724 3.374a7.291 7.291 0 0 1-1.948 2.45 8.615 8.615 0 0 1-2.827 1.505c-1.068.342-2.19.511-3.363.511h-5.68V17.325Zm3.474 12.562h1.805c.802 0 1.547-.08 2.238-.245.689-.164 1.289-.433 1.792-.812a3.94 3.94 0 0 0 1.192-1.494c.29-.616.433-1.369.433-2.26 0-.772-.145-1.444-.433-2.015a4.074 4.074 0 0 0-1.17-1.415 5.17 5.17 0 0 0-1.728-.837 7.671 7.671 0 0 0-2.082-.277h-2.05v9.355h.003ZM111.726 17.325h4.721l6.705 10.958h.045V17.325h3.474v15.769h-4.545l-6.881-11.225h-.046v11.225h-3.473V17.325ZM130.012 17.325h10.713v3.207h-7.237v2.94h6.836v3.208h-6.836v3.207h7.638v3.207h-11.114V17.325ZM144.353 17.326h6.102c.801 0 1.563.078 2.281.234a5.438 5.438 0 0 1 1.894.78c.541.363.971.853 1.292 1.47.32.615.478 1.385.478 2.305 0 1.114-.29 2.06-.869 2.838-.578.78-1.425 1.273-2.539 1.48L157 33.092h-4.164l-3.296-6.304h-1.714v6.304h-3.473V17.323v.003Zm3.473 6.527h2.05c.312 0 .643-.01.99-.032.35-.022.665-.09.947-.2.283-.11.517-.285.703-.524.185-.237.277-.57.277-1 0-.402-.081-.722-.245-.959a1.645 1.645 0 0 0-.624-.546 2.738 2.738 0 0 0-.869-.255 6.916 6.916 0 0 0-.958-.068h-2.271v3.587-.003Z"
        fill="#000"
      />
      <g clip-path="url(#a)">
        <path d="M0 .553v32.539h32.539V.552H0Z" fill="#D4BE8B" />
        <path
          d="M0 20.467c1.51-.807 3.748-.677 5.935.312.286-.104.599-.208.885-.286-2.447-1.276-4.972-1.562-6.82-.73v.704ZM17.597 22.575c.156.104.338.208.495.312a8.08 8.08 0 0 0 1.015-.156c-.39-.235-.807-.469-1.172-.73-1.64-1.014-3.201-1.978-5.258-1.978C9.371 20.023 4.66 21.56 0 24.11v.703l.026.026c4.66-2.603 9.397-4.165 12.677-4.165 1.848.026 3.254.885 4.894 1.9ZM32.539 23.174c-.39.182-3.124 1.38-7.289 1.38-1.171 0-2.187-.157-3.098-.443-.416.104-.807.208-1.171.286 1.223.469 2.603.807 4.295.807 3.8 0 6.404-.937 7.289-1.301v-.73h-.026Z"
          fill="#000"
        />
        <path
          d="M32.539 17.629c-7.705 5.883-15.593 6.065-16.478 6.065-2.395 0-4.477-.546-6.898-1.874-.286.078-.599.156-.911.234 2.785 1.614 5.102 2.29 7.81 2.29.884 0 8.694-.181 16.477-5.908v-.807Z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(0 .553)"
            d="M0 0h32.539v32.539H0z"
          />
        </clipPath>
      </defs>
    </svg>
    <!--   Anniversary logo   -->
    <svg
      v-else
      key="logo-mobile-anniversary"
      width="100%"
      height="100%"
      viewBox="0 0 157 34"
      xmlns="http://www.w3.org/2000/svg"
      class="logo--default inline-block lg:hidden"
    >
      <title>{{ $t('header.logo_title') }}</title>
      <g transform="scale(0.603,0.608)">
        <path
          d="M98.5,38.2c-1.6,0.9-3.4,1.5-5.2,1.9c-1.8,0.4-3.6,0.6-5.6,0.6c-2,0-3.9-0.3-5.6-0.9s-3.1-1.6-4.4-2.7
		c-1.2-1.2-2.2-2.6-2.9-4.3c-0.7-1.6-1.1-3.6-1.1-5.6s0.4-3.9,1.1-5.6s1.6-3.1,2.9-4.3c1.2-1.2,2.7-2.1,4.4-2.7
		c1.7-0.6,3.6-0.9,5.6-0.9s3.9,0.3,5.7,0.7c1.8,0.4,3.3,1.4,4.6,2.6l-4,4.4c-0.8-0.8-1.6-1.4-2.6-1.8c-1-0.4-2.2-0.6-3.6-0.6
		c-1.2,0-2.3,0.2-3.3,0.6c-1,0.4-1.9,1-2.5,1.7c-0.7,0.7-1.2,1.6-1.6,2.6c-0.4,1-0.6,2.1-0.6,3.3c0,1.2,0.2,2.4,0.6,3.4
		c0.4,1,0.9,1.9,1.6,2.6s1.6,1.3,2.5,1.7c1,0.4,2.1,0.6,3.3,0.6c1.2,0,2.3-0.1,3.2-0.4s1.6-0.6,2.1-0.9V30h-4.6v-5.2h10V38.2
		L98.5,38.2L98.5,38.2z"
        />
        <path
          d="M108.7,27.1c0,1.2,0.2,2.4,0.6,3.4c0.4,1,0.9,1.9,1.6,2.6c0.7,0.7,1.6,1.3,2.5,1.7c1,0.4,2.1,0.6,3.3,0.6s2.3-0.2,3.3-0.6
		c1-0.4,1.8-1,2.5-1.7c0.7-0.7,1.2-1.6,1.6-2.6c0.4-1,0.6-2.1,0.6-3.4c0-1.2-0.2-2.3-0.6-3.3c-0.4-1-0.9-1.9-1.6-2.6
		c-0.7-0.7-1.6-1.3-2.5-1.7c-1-0.4-2.1-0.6-3.3-0.6c-1.2,0-2.3,0.2-3.3,0.6s-1.9,1-2.5,1.7c-0.7,0.7-1.2,1.6-1.6,2.6
		C108.9,24.9,108.7,25.9,108.7,27.1L108.7,27.1z M102.8,27.1c0-2.1,0.4-3.9,1.1-5.6c0.7-1.6,1.6-3.1,2.9-4.3
		c1.2-1.2,2.7-2.1,4.4-2.7c1.7-0.6,3.6-0.9,5.6-0.9c2,0,3.9,0.3,5.6,0.9c1.7,0.6,3.1,1.6,4.4,2.7c1.2,1.2,2.2,2.6,2.9,4.3
		c0.7,1.6,1.1,3.6,1.1,5.6s-0.4,3.9-1.1,5.6c-0.7,1.7-1.6,3.1-2.9,4.3c-1.2,1.2-2.7,2.1-4.4,2.7c-1.7,0.6-3.6,0.9-5.6,0.9
		s-3.9-0.3-5.6-0.9c-1.7-0.6-3.1-1.6-4.4-2.7c-1.2-1.2-2.2-2.6-2.9-4.3C103.2,31.1,102.8,29.2,102.8,27.1L102.8,27.1z"
        />
        <polygon
          points="134.7,14.2 140.4,14.2 140.4,34.8 150.9,34.8 150.9,40.1 134.7,40.1 134.7,14.2 	"
        />
        <path
          d="M161.9,34.8h2.9c1.3,0,2.5-0.1,3.6-0.4c1.1-0.3,2.1-0.7,2.9-1.4c0.8-0.6,1.5-1.4,1.9-2.4c0.5-1,0.7-2.2,0.7-3.7
		c0-1.3-0.2-2.4-0.7-3.3c-0.5-0.9-1.1-1.7-1.9-2.3c-0.8-0.6-1.7-1.1-2.9-1.4c-1.1-0.3-2.2-0.4-3.4-0.4h-3.4L161.9,34.8L161.9,34.8
		L161.9,34.8z M156.1,14.2h8.5c2.1,0,4,0.2,5.9,0.7c1.9,0.4,3.5,1.2,4.9,2.2c1.4,1,2.5,2.4,3.3,4c0.8,1.6,1.2,3.6,1.2,6
		c0,2.1-0.4,3.9-1.2,5.5c-0.8,1.6-1.9,2.9-3.2,4c-1.4,1.1-2.9,1.9-4.6,2.4c-1.7,0.6-3.6,0.9-5.5,0.9H156L156.1,14.2L156.1,14.2
		L156.1,14.2z"
        />
        <polygon
          points="184.5,14.2 192.2,14.2 203.1,32.1 203.3,32.1 203.3,14.2 208.9,14.2 208.9,40.1 201.5,40.1 190.3,21.6 190.2,21.6
		190.2,40.1 184.5,40.1 184.5,14.2 	"
        />
        <polygon
          points="214.3,14.2 231.8,14.2 231.8,19.5 220,19.5 220,24.3 231.2,24.3 231.2,29.6 220,29.6 220,34.8 232.5,34.8
		232.5,40.1 214.3,40.1 214.3,14.2 	"
        />
        <path
          d="M243.4,24.9h3.4c0.5,0,1.1,0,1.6-0.1c0.6-0.1,1.1-0.1,1.6-0.4c0.4-0.2,0.9-0.5,1.1-0.9c0.3-0.4,0.4-0.9,0.4-1.6
		c0-0.6-0.1-1.2-0.4-1.6c-0.3-0.4-0.6-0.7-1-0.9c-0.4-0.2-0.9-0.4-1.4-0.4c-0.6-0.1-1.1-0.1-1.6-0.1h-3.7L243.4,24.9L243.4,24.9
		L243.4,24.9z M237.7,14.2h10c1.3,0,2.6,0.1,3.7,0.4c1.2,0.3,2.2,0.7,3.1,1.3c0.9,0.6,1.6,1.4,2.1,2.4c0.5,1,0.8,2.3,0.8,3.8
		c0,1.8-0.5,3.4-1.4,4.6c-0.9,1.3-2.4,2.1-4.1,2.4l6.6,10.9h-6.8l-5.4-10.4h-2.8v10.4h-5.7V14.2L237.7,14.2L237.7,14.2z"
        />
      </g>
      <g transform="scale(0.603,0.608)">
        <polygon
          fill="#D1C092"
          points="2,13.3 3.4,19 6.6,19.2 6.4,41.3 13.9,41.3 13.9,13.3 	"
        />
        <g>
          <g>
            <g fill="#D1C092">
              <path
                d="M30,35.7c-4.8,0-8.7-3.8-8.7-8.4s3.9-8.5,8.7-8.5s8.7,3.8,8.7,8.5S34.8,35.7,30,35.7 M30,13.2
					c-8,0-14.5,6.3-14.5,14.1S22,41.3,30,41.3S44.5,35,44.5,27.2S37.9,13.2,30,13.2"
              />
              <path
                d="M65.5,21.3c-0.7-1.4-1.6-2.7-2.7-3.8l0,0l-0.4-0.4c-0.4-0.4-1-0.8-1.5-1.2c-1-0.7-2.1-1.3-3.1-1.7
					c0,0-0.1,0-0.1-0.1c-0.1,0-0.1,0-0.1-0.1c-2.1-0.8-4.5-1-6.9-0.7c-3.7,0.5-7,2.5-9.3,5.5c-2.2,3-3.2,6.7-2.7,10.4
					c0.5,3.7,2.5,7,5.5,9.3c0.5,0.4,1,0.7,1.6,1l0.5,0.3l0,0c1.4,0.7,3,1.2,4.6,1.4h0.4l5-7.2c-0.7,0.4-1.5,0.7-2.4,0.8
					c-4.1,0.7-8.1-2.1-8.8-6.3c-0.7-4.1,2.1-8.1,6.3-8.8c1.3-0.2,2.7-0.1,3.9,0.4l0,0c0,0,0.1,0,0.1,0.1c2.4,1,4.4,3.2,4.7,6
					c0.1,0.8,0.1,1.7-0.1,2.4L65.5,21.3L65.5,21.3z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>

    <svg
      height="100%"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="logo--minimal w-[52px]"
    >
      <g clip-path="url(#a)">
        <path d="M0 .553v32.539h32.539V.552H0Z" fill="#D4BE8B" />
        <path
          d="M0 20.467c1.51-.807 3.748-.677 5.935.312.286-.104.599-.208.885-.286-2.447-1.276-4.972-1.562-6.82-.73v.704ZM17.597 22.575c.156.104.338.208.495.312a8.08 8.08 0 0 0 1.015-.156c-.39-.235-.807-.469-1.172-.73-1.64-1.014-3.201-1.978-5.258-1.978C9.371 20.023 4.66 21.56 0 24.11v.703l.026.026c4.66-2.603 9.397-4.165 12.677-4.165 1.848.026 3.254.885 4.894 1.9ZM32.539 23.174c-.39.182-3.124 1.38-7.289 1.38-1.171 0-2.187-.157-3.098-.443-.416.104-.807.208-1.171.286 1.223.469 2.603.807 4.295.807 3.8 0 6.404-.937 7.289-1.301v-.73h-.026Z"
          fill="#000"
        />
        <path
          d="M32.539 17.629c-7.705 5.883-15.593 6.065-16.478 6.065-2.395 0-4.477-.546-6.898-1.874-.286.078-.599.156-.911.234 2.785 1.614 5.102 2.29 7.81 2.29.884 0 8.694-.181 16.477-5.908v-.807Z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(0 .553)"
            d="M0 0h32.539v32.539H0z"
          />
        </clipPath>
      </defs>
    </svg>
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps({
  linkTo: {
    type: String as PropType<string>,
    default: '/',
  },
  isFlyoutMenu: {
    type: Boolean,
    default: false,
  },
})

const { toLocalePath } = useRouteHelpers()
const { isGoldnerAnniversary } = useGlobalConfig()
</script>

<style lang="scss" scoped>
.logo--default {
  @apply hidden;
  @media (min-width: 350px) {
    @apply inline-block lg:hidden;
  }
}

.logo--minimal {
  @apply inline-block;
  @media (min-width: 350px) {
    display: none;
  }
}
</style>
